import gql from "graphql-tag";

export const SUBSCRIPTION_QUERY = gql`
  query subscriptionQuery($isActive: Boolean) {
    inventory(isActive: $isActive) {
      expiryDate
      reaId
      user {
        id
        organisation {
          id
          isAgency
          isBranch
        }
      }
      provisionedBy {
        type {
          code
          description
        }
        provisioned {
          listingProduct {
            code
            description
          }
          expiryDate
          title
          type
          duration
          statuses {
            available
            used
          }
          nextQuaterAllocation {
            startDate
            statuses {
              available
            }
          }
        }
      }
    }
  }
`;

export const ALLOCATION_QUERY = gql`
  query userAllocationQuery {
    userAllocation {
      organisationId
      organisation {
        id
        isAgency
        isBranch
      }
      reaId
      expiryDate
      overview {
        productCode
        title
        duration
        allocated
        assigned
        nonAssigned
        used
        available
        cancelled
      }
      allocations {
        organisationId
        userId
        reaId
        products {
          productCode
          listingProduct {
            id
            code
            description
          }
          title
          duration
          allocated
          assigned
          nonAssigned
          used
          remaining: available
          cancelled
        }
      }
    }
  }
`;

export const INVENTORY_FRAGMENT = gql`
  fragment InventoryFragment on Inventory {
    user {
      id
    }
    provisionedBy {
      conversion {
        type
        fromType
        statuses {
          provisioned
        }
        statusBreakdown {
          provisioned {
            expiryDate
            total
            summaryType {
              code
            }
          }
        }
      }
      provisioned {
        type
        statuses {
          used
          available
          provisioned
        }
        statusBreakdown {
          used {
            isCarryOver
            expiryDate
            total
            summaryType {
              code
            }
          }
          provisioned {
            isCarryOver
            expiryDate
            total
            summaryType {
              code
            }
          }
          available {
            isCarryOver
            expiryDate
            total
            summaryType {
              code
            }
          }
        }
      }
    }
  }
`;

export const MY_SUBSCRIPTION_QUERY = gql`
  query MYSubscriptionQuery($isActive: Boolean) {
    subscription {
      startDate
      endDate
      name
      region
      locationLevel1Ids
    }
    subscriptionCapability {
      isPackageRenewable
    }
    inventory(isActive: $isActive) {
      ...InventoryFragment
    }
    viewer {
      id
      accountManager {
        avatar
        displayName
        email
        contact {
          agentEmail
          primaryPhone {
            number
          }
          secondaryPhone {
            number
          }
          didPhone {
            number
          }
        }
      }
    }
  }
  ${INVENTORY_FRAGMENT}
`;

export const INVENTORY_HISTORY_QUERY = gql`
  query inventoryHistory($isActive: Boolean) {
    inventory(isActive: $isActive) {
      ...InventoryFragment
    }
  }
  ${INVENTORY_FRAGMENT}
`;

export const MY_SUBSCRIPTION_CAPABILITY_QUERY = gql`
  query MYSubscriptionCapabilityQuery {
    subscriptionCapability {
      isPackageRenewable
    }
  }
`;

export const GET_READVERTISE_CREDIT_USAGE = gql`
  query reAdvertiseCreditUsage {
    reAdvertiseCreditUsage {
      totalOrgCost
      totalOwnCost
    }
  }
`;

export const SPECIALIST_DETAIL_SUMMARY = gql`
  query summaryDetailSpecialist {
    summaryDetailSpecialist {
      data {
        id
        type {
          code
          description
        }
        status {
          code
          description
        }
        building {
          id
          text {
            en_GB
          }
        }
        locationLevel2 {
          id
          text {
            en_GB
          }
        }
        startDate
        expiryDate
        numberOfListing
        config {
          listingNumber
          productGroup {
            code
            description
          }
        }
      }
    }
  }
`;

export const CREDIT_USAGE_QUERY = gql`
  query creditUsageQuery(
    $page: String
    $dateFrom: String
    $dateTo: String
    $listingId: ID
    $activityGroupCodes: [Int]
    $creditTypeCode: Int
  ) {
    creditUsage(
      page: $page
      dateFrom: $dateFrom
      dateTo: $dateTo
      listingId: $listingId
      activityGroupCodes: $activityGroupCodes
      creditTypeCode: $creditTypeCode
    ) {
      pagination {
        nextPageToken
        limit
        page
        total
      }
      data {
        listingId
        listingPreviewLink
        specialistId
        date
        activity {
          title
          description
        }
        creditType {
          description
        }
        cost
        channel {
          description
        }
      }
    }
  }
`;
